import { ProStoragePlan } from "ts/api/constraints";

const getShowFileUploadLimit = (currentPlan?: ProStoragePlan) => {
  if (!currentPlan) {
    return 10;
  }
  if (!currentPlan.storageLimit) {
    return null;
  }
  return currentPlan.storageLimit;
};

export default getShowFileUploadLimit;
